export { NewUserFollowSponsors as Sponsors } from './NewUserFollowSponsors';
